<div id="payment" *ngIf="showWallet">
  <div>
    <i class="fas fa-shopping-cart"></i> {{ paymentStripeService.wallet|money }}
    <i class="fas fa-sync-alt q-pointer" *ngIf="!isLoading" (click)="refreshWallet()" title="Actualiser"></i>
    <div *ngIf="isLoading" class="ag-custom-loading-cell loader">
      <i class="fas fa-spinner fa-pulse"></i>
    </div>
  </div>
  <button title="Créditer le portefeuille" *ngIf="price > paymentStripeService.wallet && !isLoading" (click)="displayStripe()" class="q-btn q-main" id="add"><i class="fas fa-plus"></i></button>
</div>
